import React from "react";
import SectionHeader from "../section/SectionHeader";
import kitchenBg from "../../../assets/images/banner-back-1.jpg";
import Cards from "../../cards/Cards3";
import QuoteForm from "../../QuoteForm";
import Navbar4 from "../../Navbar4";

const HomeExtention = () => {
  return (
    <>
      <div className="container-fluid mb-4 mt-3">
        <SectionHeader
          title="HOME EXTENSIONS"
          backgroundImage={kitchenBg}
          className=""
        />
      </div>

      <div className="container my-3">
        <div className="row">
          <div className="col-lg-9">
            <div className="px-1 my-4" >
              <h1
                data-sal="slide-right"
                data-sal-duration="1000"
                data-sal-delay="200"
                className="text-center mb-4"
                style={{
                  fontFamily: "Barlow Condensed",
                  fontWeight: "600",
                  fontSize: "2rem",
                }}
              >
                Home Extensions
              </h1>
              <img
                data-sal="fade"
                data-sal-duration="1000"
                data-sal-delay="300"
                src="assets/Images/Home/home7.jpg"
                alt="banner"
                className="mb-3"
                style={{
                  width: "100%",
                  float: "left",
                  height: "200px",
                  objectFit: "cover",
                  marginTop: "0px",
                }}
              />

              <p  data-sal="fade"
                data-sal-duration="2000"
                data-sal-delay="200"
                className="text-start my-4"  
                style={{ fontFamily: "Barlow Condensed" }}
              >
                At Velar Heights Renovation, we bring your home expansion ideas
                to life. Since 2001, our team has been crafting exceptional
                modular home additions across the Toronto area, completing
                nearly 1,000 projects. Whether you're looking to add an extra
                room or completely transform your home, our skilled
                professionals are here to create beautiful, functional spaces
                that enhance your home’s value and comfort.
              </p>

              <h2  data-sal="slide-left"
                data-sal-duration="2000"
                data-sal-delay="200"
                className="text-start"
                style={{
                  fontFamily: "Barlow Condensed",
                  fontWeight: "normal",
                  fontSize: "1.5rem",
                }}
              >
                Why We’re Toronto’s Top Choice for Home Additions
              </h2>

              <p
                className="text-start"
                style={{ fontFamily: "Barlow Condensed" }}
              >
                Our reputation as the leading home addition specialists in
                Toronto isn’t built on advertising—it’s rooted in our unwavering
                commitment to customer satisfaction. At Velar Heights
                Renovations, we treat every client as our most important
                customer and every home as if we were working on our own. This
                personal approach ensures that each project reflects the highest
                standards of quality and craftsmanship.
              </p>

              <h2
                className="text-start"
                style={{
                  fontFamily: "Barlow Condensed",
                  fontWeight: "normal",
                  fontSize: "1.5rem",
                }}
              >
                Comprehensive Home Addition Services
              </h2>

              <p
                className="text-start"
                style={{ fontFamily: "Barlow Condensed" }}
              >
                {" "}
                <p>
                  <strong>Comprehensive Home Addition Services:</strong> We take
                  immense pride in the quality and precision of the home
                  renovations and additions we deliver. Our award-winning and
                  experienced team guides you through every step of the process,
                  ensuring alignment with your vision from start to finish. This
                  comprehensive service includes:
                </p>
                <p>
                  <strong>Planning and Design:</strong> We collaborate with you
                  to understand your needs and preferences, creating detailed
                  plans and designs that align with your goals.
                </p>
                <p>
                  <strong>Permits and Approvals:</strong> We handle all
                  necessary permits and approvals to ensure that your project
                  complies with local regulations.
                </p>
                <p>
                  <strong>Construction and Installation:</strong> Our skilled
                  contractors execute the renovation and addition work with
                  meticulous attention to detail, ensuring a seamless
                  integration with your existing home.
                </p>
                <p>
                  <strong>Our Range of Home Addition Services:</strong> Velar
                  Heights Renovation offers a broad spectrum of home addition
                  services tailored to enhance your living space. Our services
                  include:
                </p>
                <p>
                  <strong>Second-Story Additions:</strong> Adding a new floor to
                  your home provides additional living space and can
                  significantly boost your property’s value.
                </p>
                <p>
                  <strong>Ground-Floor Extensions:</strong> Expand your existing
                  footprint with ground-floor extensions that enhance
                  functionality and aesthetics.
                </p>
                <p>
                  <strong>Rear Additions and Bump-Out Extensions:</strong>{" "}
                  Perfect for adding extra space to your kitchen, living area,
                  or dining room, these additions are designed to blend
                  seamlessly with your home’s architecture.
                </p>
                <p>
                  <strong>Custom Additions:</strong> From family rooms and
                  kitchens to bedrooms and more, we create stunning home
                  additions that meet your specific needs.
                </p>
              </p>

              <h2
                className="text-start"
                style={{
                  fontFamily: "Barlow Condensed",
                  fontWeight: "normal",
                  fontSize: "1.5rem",
                }}
              >
                Why Choose Us for Your Home Addition Project
              </h2>

              <p
                className="text-start"
                style={{ fontFamily: "Barlow Condensed" }}
              >
                With over 20 years of industry experience, Velar Heights
                Renovation is committed to delivering the highest quality
                service. Our skilled team works closely with clients throughout
                the entire process, from the initial consultation to the final
                walkthrough. We ensure that every project is completed on time,
                within budget, and to the highest standards of quality and
                safety. Our meticulous attention to detail and dedication to
                customer satisfaction have made us the preferred choice for home
                additions in Toronto.
              </p>
            </div>
          </div>

          <div className="col-lg-3 d-flex flex-column justify-content-start">
            <div className="mb-3" style={{ marginTop: "85px" }}>
              <QuoteForm />
            </div>
            <Navbar4 />
          </div>
        </div>
      </div>

      <div >
        <h1 data-sal='slide-down' data-sal-duration="2000" data-sal-delay="300"
          className="text-center"
          style={{
            fontFamily: "Barlow Condensed",
            fontWeight: "lighter",
            fontSize: "4rem",
          }}
        >
          Our Portfolio
        </h1>
      </div>

      <Cards />
    </>
  );
};

export default HomeExtention;
